import type { DetailLevel } from '@heidi/growth';
import type { TranslationKey } from '@heidi/runtime/i18n';

export const DETAIL_LEVELS: {
  value: DetailLevel;
  labelKey: TranslationKey;
  descKey: TranslationKey;
}[] = [
  {
    value: 'low',
    labelKey: 'signup.detailLevelLow',
    descKey: 'signup.detailLevelLowDesc',
  },
  {
    value: 'medium',
    labelKey: 'signup.detailLevelMedium',
    descKey: 'signup.detailLevelMediumDesc',
  },
  {
    value: 'high',
    labelKey: 'signup.detailLevelHigh',
    descKey: 'signup.detailLevelHighDesc',
  },
];
